var _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgFilterDesc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "314.171 237.982 16.851 23.391",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "hsla(0, 0%, 25.1%, 1.000)",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(1, 0, 0, 1, 310.420541, 238.125007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.25 23.248 L 8.25 0.748 M 3.75 4.5 L 8.25 0 L 12.75 4.5 M 16.1 13.999 L 19.7 13.999 C 20.337 13.998 20.773 14.642 20.536 15.233 L 16.164 21.764 C 15.927 22.356 16.363 22.999 17 22.999 L 20.6 22.999 M 20.25 8.859 L 20.25 2.111 C 20.25 0.379 18.375 -0.704 16.875 0.162 C 16.179 0.564 15.75 1.307 15.75 2.111 L 15.75 8.861 M 15.75 5.859 L 20.25 5.859"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterDesc);
export default __webpack_public_path__ + "static/media/FilterDesc.237aa51f.svg";
export { ForwardRef as ReactComponent };